import { render } from "./Others.vue?vue&type=template&id=34b52714&scoped=true"
import script from "./Others.vue?vue&type=script&lang=js"
export * from "./Others.vue?vue&type=script&lang=js"

import "./Others.vue?vue&type=style&index=0&id=34b52714&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34b52714"]])

export default __exports__